import { render, staticRenderFns } from "./RegAddOnListItem.vue?vue&type=template&id=4d55f5d8&scoped=true&"
import script from "./RegAddOnListItem.vue?vue&type=script&lang=js&"
export * from "./RegAddOnListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegAddOnListItem.vue?vue&type=style&index=0&id=4d55f5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55f5d8",
  null
  
)

export default component.exports